import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LicenseLogin } from "../../_interfaces/LicenseLogin"
import { HttpFunctionResult } from "../../_interfaces/HttpFunctionResult"
import { FeedbackService, MsgType } from "../../_provider/feedback.service"
import { DarkmodeService } from "../../_provider/darkmode.service"

@Component({
  selector: 'app-release-license',
  templateUrl: './release-license.page.html',
  styleUrls: ['./release-license.page.scss'],
})
export class ReleaseLicensePage implements OnInit {

  public licenses: LicenseLogin[] = []

  public activeLicense: LicenseLogin = null

  constructor(
    private feedback: FeedbackService,
    private modalCtrl: ModalController,
    public darkmode: DarkmodeService
  ) { }

  async ngOnInit() {
    await this.feedback.showMsg(MsgType.Error, `
      Es sind bereits 3 Geräte mit Ihrem Benutzer-Account verknüpt.
      Bitte wählen Sie ein Gerät aus, welches von Ihrem Account entfernt werden soll, um sich anzumelden.
      `)
  }

  public async submit(){
    if(!this.activeLicense) return
    await this.modalCtrl.dismiss({
      success: true,
      data: this.activeLicense
    } as HttpFunctionResult<LicenseLogin>)
  }

  public async cancel(){
    await this.modalCtrl.dismiss({success: false} as HttpFunctionResult<LicenseLogin>)
  }

}
